// extracted by mini-css-extract-plugin
module.exports = {"skeletonWrapper":"Skeleton_skeletonWrapper__2zMTT"};